import React from 'react'
import { Container, TextCaption, TextBody } from '@pmi/pmi-iqos-ds-react'

const DeviceInfo = ({ label, dataTestingSuffix, children }) => {
  return (
    <Container pt="2" display={Container.displays.flex}>
      <Container width="5/12">
        <TextCaption size={TextCaption.sizes.s}>{label}</TextCaption>
      </Container>
      <Container width="7/12">
        {children && typeof children === 'string' ? (
          <TextBody
            size={TextBody.sizes.s}
            style={TextBody.styles.grayedout}
            data-testing={
              dataTestingSuffix && 'Profile_TextBody_' + dataTestingSuffix
            }>
            {children}
          </TextBody>
        ) : (
          children
        )}
      </Container>
    </Container>
  )
}

export default DeviceInfo
